import Api from "../apiService";

class counterpartiesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/counterparties`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/counterparties/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/counterparties`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/counterparties/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/counterparties/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/counterparties/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }

  export(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/counterparties/export`,
      params,
      Api.authHeaders(),
      { responseType: "blob" } // важно для получения файла
    );
  }
}

export default new counterpartiesApi();
